import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@apollo/client";
import { GET_UNREAD_COUNTS } from "../../services/apollo/queries/conversationQueries";
import { setNotifications } from "../../slices/messagesSlice";
import socket from "../../services/socketClient";

const useUnreadCounts = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const { data, loading, error } = useQuery(GET_UNREAD_COUNTS, {
    fetchPolicy: "network-only",
    skip: !user || !user._id,
  });

  useEffect(() => {
    socket.on("unreadUpdate", ({ conversationId, unreadCount }) => {
      dispatch(setNotifications([{ _id: conversationId, unreadCount }]));
    });
  
    return () => socket.off("unreadUpdate");
  }, [dispatch]);

  useEffect(() => {
    if (data?.getConversations) {
      dispatch(setNotifications(data.getConversations));
    }
  }, [data, dispatch]);

  return { data, loading, error };
};

export default useUnreadCounts;